import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MAuthGuard } from '@mercadona/core/auth';
import { MPageNotFoundComponent } from '@mercadona/core-ui/page-not-found';

// IMPORTANT: Do not use the "/error" route as it will be overwritten by the Core module. More info:
// https://mus.mercadona.com/39eafa15b/v/0/p/014302-page-error
// IMPORTANT: Do not use the "/monitoring_nginx" route as it will be overwritten by Nginx Configuration
// IMPORTANT: Do nout user the "/callback" as it will be overwritten by the Token module. More info:
// https://mus.mercadona.com/39eafa15b/v/0/p/043ae9-rutas-no-permitidas

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'error'
  },
  {
    path: 'video2025',
    canActivate: [MAuthGuard],
    loadChildren: () => import('./pages/annual-2025/annual-2025-page.module').then((m) => m.Annual2025PageModule)
  },
  {
    path: 'resultados2024',
    canActivate: [MAuthGuard],
    loadChildren: () => import('./pages/annual-2024/annual-2024-page.module').then((m) => m.Annual2024PageModule)
  },
  {
    path: 'anual',
    loadChildren: () => import('./pages/anual/anual-page.routes').then((m) => m.ANUAL_PAGE_ROUTES)
  },
  {
    path: '**',
    component: MPageNotFoundComponent
  }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
